import { t } from "i18next";

import StatBox from "@components/StatBox/StatBox";
import styles from "./PublishModalContent.module.scss";

interface Props {
  changes: {
    features: number;
    deletedFeatures: number;
  };
}

const PublishModalContent: React.FC<Props> = ({ changes }) => {
  return (
    <div className={styles.container}>
      <p className={styles.description}>{t("modals.publish.description")}</p>
      <div className={styles.grid}>
        <StatBox
          dataQA="unpublished-features-statbox"
          stat={changes.features}
          description={t("modals.publish.stats.unpublished")}
        />
        <StatBox
          dataQA="deleted-features-statbox"
          stat={changes.deletedFeatures}
          description={t("modals.publish.stats.archived")}
        />
      </div>
    </div>
  );
};

export default PublishModalContent;
